export default __webpack_public_path__ + "images/e47c4f71f9294a33518a75f22817c54f-lendbot.svg";